import { createRequestHelper } from '@utils/swr'
import { useMemo } from 'react'
import { type CampaignAddonProductsRequest } from '../types/apiRequest'
import { type CampaignAddonProductsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['campaignAddonProducts'], CampaignAddonProductsResponse, CampaignAddonProductsRequest>({
  client: 'fortune',
  key: params => params?.code ? `/campaigns/${params.code}/addon_products` : null,
  isImmutable: true,
})

export function useApiCampaignAddonProducts(...args: [CampaignAddonProductsRequest]) {
  const response = useRequest(...args)

  const addonProductsWithMetadata = useMemo(() =>
    response.destructuredData
      ? Object.values(response.destructuredData).flatMap(allProduct => allProduct)
      : undefined,
  [response.destructuredData])

  return {
    ...response,
    addonProductsWithMetadata,
  }
}
